import './index.css';

export const ProfileIconIndicator = () => (
  <div className='profile-icon-indicator'>
    <div className='profile-icon-indicator__circle profile-icon-indicator__circle-one' />
    <div className='profile-icon-indicator__circle profile-icon-indicator__circle-two' />
    <div className='profile-icon-indicator__circle profile-icon-indicator__circle-three' />
    <div className='profile-icon-indicator__circle profile-icon-indicator__circle-four' />
    <div className='profile-icon-indicator__circle profile-icon-indicator__circle-five' />
    <div className='profile-icon-indicator__circle profile-icon-indicator__circle-six' />
  </div>
);
